<template>
  <div>
    <report-base
      title="Occupancy"
      table-class="analytics-tables--occupancies"
      subject="occupancy"
      :items="occupancies"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from './mixin';

export default {
  name: 'analytics-occupancy',

  mixins: [
    AnalyticsMixin
  ],

  data() {
    return {
      occupancies: [],
      fields: [
        {
          key: 'room',
          label: this.$t('analytics.occupancy.room_name').toUpperCase(),
          sortable: true,
        },
        {
          key: 'room_class',
          label: this.$t('analytics.occupancy.room_class').toUpperCase(),
          sortable: true,
        },
        {
          key: 'occupancy_rate',
          label: this.$t('analytics.occupancy.occupancy').toUpperCase(),
          sortable: true,
        },
        {
          key: 'adr',
          label: this.$t('analytics.occupancy.adr').toUpperCase(),
          sortable: true,
        },
        {
          key: 'rev_par',
          label: this.$t('analytics.occupancy.revpar').toUpperCase(),
          sortable: true,
        },
        {
          key: 'revenue',
          label: this.$t('analytics.occupancy.revenue').toUpperCase(),
          sortable: true,
        },
        {
          key: 'taxes',
          label: 'Taxes',
          sortable: true,
        },
        {
          key: 'fees',
          label: 'Fees',
          sortable: true,
        },
        {
          key: 'night_count',
          label: this.$t('analytics.occupancy.no_nights').toUpperCase(),
          sortable: true,
        },
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;

      this.fetchData('occupancy')
        .then(res => {
          this.occupancies = res.data
            .map(item => {
              item.occupancy_rate = this.formatPercent(item.occupancy_rate);
              item.adr = this.formatMoney(item.adr);
              item.rev_par = this.formatMoney(item.rev_par);
              item.revenue = this.formatMoney(item.revenue);
              item.taxes = this.formatMoney(item.taxes);
              item.fees = this.formatMoney(item.fees);
              item.night_count = item.night_count
                ? item.night_count
                : '';

              return item;
            });
        })
        .catch(error => {
          this.errorNotification(error.message || 'Failed to load data');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
  .analytics-tables--occupancy {
    table {
      min-width: 1000px !important;
    }
  }
</style>
